"use client";

import { QueryClient, QueryClientProvider } from "react-query";

import dynamic from "next/dynamic";

const client = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const WebPushNotificationsDynamic = dynamic(
  async () =>
    (await import("@jti/ui/WebPushNotifications")).WebPushNotifications,
  { ssr: false }
);

export const WebPushNotifications = () => (
  <QueryClientProvider client={client}>
    <WebPushNotificationsDynamic />
  </QueryClientProvider>
);
